<script>

    import { createEventDispatcher } from 'svelte'
    import { eventStore } from '../stores'

    const dispatch = createEventDispatcher()

    export let event = ''

    $: $eventStore && $eventStore ===  event && dispatchEvent()

    function dispatchEvent() {
        console.log(event)
        dispatch('dispatch')
        eventStore.set(null)
    }

</script>